import React, { useState, useEffect } from "react";
import '../assets/css/edit.css';
import { useDispatch, useSelector } from "react-redux";
import { setIsAuthenticated } from "../redux/reducers/authSlice";
import { setUserData } from "../redux/reducers/masterDataSlice";
import RegexPattern from "../utils/regexPattern";
import { useNavigate } from 'react-router-dom';
import { apiCallingPost } from "../api/services";
import { toast } from 'react-toastify';
import SignupForm from "./signup-form";
import Loader from "../assets/images/loader.gif"

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [signup, showSignup] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const { pageUrl } = useSelector((state) => state.authentication);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    document.getElementById("username").focus();

    // 🔹 Handle Google redirect (id_token comes in URL hash)
    if (window.location.hash) {
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const idToken = hashParams.get("id_token");
      console.log(".....idToken......",idToken);

      if (idToken) {
      console.log(".....idToken...innn...",idToken);

        handleCredentialResponse({ credential: idToken });

        // Optional: clean the URL so hash doesn’t stay visible
        window.history.replaceState(null, "", window.location.pathname);
      }
    }
  }, []);

  const handleCredentialResponse = async (response) => {
    setLoading(true)
    console.log(".....response......",response);
    
    try {    
      const data = await apiCallingPost("api/authentication/googleAuth", {
        token: response.credential,
      });
      console.log(".....data......",data);

      if (data.data.success === "1") {
        dispatch(setIsAuthenticated(true));
        dispatch(setUserData(data.data.userData[0]));
        toast.success(data.data.successMessage);
        setLoading(false)
        setTimeout(() => {
          if (data.data.userData[0].roleDisplayName === "Super_admin") {
            navigate("/admin-list");
          } else {
            navigate(pageUrl);
          }
        }, 1500);
      } else {
        dispatch(setIsAuthenticated(false));
        dispatch(setUserData([]));
        toast.error("Login Failed!");
        setLoading(false)

      }
    } catch (err) {
      toast.error("Login Failed!");
      console.error("Login failed", err);
      setLoading(false)
    }
  };

  // EMAIL/PASSWORD LOGIN
  const handleLogin = async (e) => {
    e.preventDefault();
    setSubmitFlag(true);

    if (!userName) {
      toast.error("Please enter your email.");
      setSubmitFlag(false);
      return;
    }

    if (!userName.match(RegexPattern.Email)) {
      toast.error("The entered email seems invalid.");
      setSubmitFlag(false);
      return;
    }

    if (!password) {
      toast.error("Please enter your password.");
      setSubmitFlag(false);
      return;
    }

    try {

      let postData = {
        email: userName,
        password: password,
      };
      setLoading(true)

      const data = await apiCallingPost("api/authentication/googleLogin", postData);

      if (data.data.success === "1") {
        dispatch(setIsAuthenticated(true));
        dispatch(setUserData(data.data.userData[0]));
        toast.success(data.data.successMessage);
      setLoading(false)

        setTimeout(() => {
          if (data.data.userData[0].roleDisplayName === "Super_admin") {
            navigate("/admin-list");
          } else {
            navigate(pageUrl);
          }
        }, 1500);
      } else {
        dispatch(setIsAuthenticated(false));
        dispatch(setUserData([]));
        toast.error(data.data.errorMessage);
      setLoading(false)

      }
    } catch (err) {
      toast.error("Login Failed!");
    } finally {
      setSubmitFlag(false);
    }
  };

  // 🔹 Employee Login → Redirect-based Google OAuth
  const handleClick = () => {
    console.log(".....innnnn...handleClick...");

    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri =  process.env.REACT_APP_GOOGLE_LOGIN_REDIRECT_URL; // must match in Google Console

    const oauth2Endpoint = "https://accounts.google.com/o/oauth2/v2/auth";
    const nonce = Math.random().toString(36).substring(2);
    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: "token id_token", // ✅ tokens only
      scope: "openid email profile",
      include_granted_scopes: "true",
      state: "employee-login",
      nonce:nonce
    });
    console.log(".....params......",params);

    // Redirect to Google OAuth
    window.location.href = `${oauth2Endpoint}?${params.toString()}`;
  };
  const setLoginHandler = async (e) => {
    e.preventDefault();
    setSubmitFlag(true);

    if (!userName) {
      toast.error("Please enter your email.");
      setSubmitFlag(false);
      return;
    }

    if (!userName.match(RegexPattern.Email)) {
      toast.error("The entered email seems invalid.");
      setSubmitFlag(false);
      return;
    }

    if (!password) {
      toast.error("Please enter your password.");
      setSubmitFlag(false);
      return;
    }

    try {
      setLoading(true)

      const postData = {
        userName: userName,
        password: password
      };

      const data = await apiCallingPost("api/authentication/userLogin", postData);
      if (data.data.success === "1") {
      setLoading(false)

        dispatch(setIsAuthenticated(true));
        dispatch(setUserData(data.data.userData[0]));
        toast.success(data.data.successMessage);
        setTimeout(() => {
          if (data.data.userData[0].roleDisplayName === "Super_admin") {
            navigate("/admin-list");
          } else {
            navigate(pageUrl);
          }
        }, 1500);


      } else {
        dispatch(setIsAuthenticated(false));
        dispatch(setUserData([]));
      setLoading(false)

        toast.error(data.data.errorMessage);
      }
    } catch (error) {
      console.error("🚀 ~ Login ~ error:", error);
    } finally {
      setSubmitFlag(false);
    }
  };
  return (
    !signup ? (
      <div className='right_login'>
        {loading === false ?
        <div className='right_login_inner'>
        <form onSubmit={setLoginHandler}>
          {/* <form onSubmit={handleLogin}> */}
            <h2 className='right_loginhead'>Sign In</h2>
            <div className='py-3 signup-sub-text'>
              Sign up now and get access to exclusive content!
            </div>
            <div className="form_div">
              <input
                type='text'
                id="username"
                placeholder="Username"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className='form_login'
              />
            </div>
            <div className="form_div">
              <input
                type='password'
                id="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className='form_login'
              />
            </div>
            <p className="forgot-pwd-sec text-end">
              <span className="signup-text">
                New User?{" "}
                <span className="ms-2 cursor-pointer" onClick={() => showSignup(true)}>
                  Sign Up
                </span>
              </span>
            </p>
            <button type='submit' disabled={submitFlag} className='login_btn'>
              Sign In
            </button>
            <p className="forgot-pwd-sec text-end">
              <span className="signup-text">
                <span className="ms-2 cursor-pointer" onClick={handleClick}>
                  Employee Login
                </span>
              </span>
            </p>
            <div className='py-3 privacy-text'>
              By clicking on Sign up, you agree to our Terms of service and Privacy policy.
            </div>
          </form>
          <div className='copyright'>
            © 2024 Visit Qatar. All rights reserved.
          </div>
        </div>
        :
        <div className="noData d-flex flex-column">
                <div>
                  <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
                </div>
              </div>}
      </div>
      
    ) : (
      <SignupForm signup={signup} showSignup={showSignup} />
    )
  );
}

export default Login;
